<template>
<div>
  <label>Inappropriate</label>
  <v-radio-group
    :row="true"
    v-model="val"
    @change="changeValue"
  >
    <v-radio label="Hide" value="hide"/>
    <v-radio label="Show" value="show"/>
    <v-radio label="Only" value="only"/>
  </v-radio-group>
</div>
</template>

<script>
export default {
  props: {
    value: String
  },
  data () {
    return {
      val: this.value
    }
  },
  methods: {
    changeValue () {
      this.$emit('input', this.val)
      this.$emit('change', this.val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// InappropriateFilter.vue?1ba04ede